import React from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableHeader
} from 'material-ui/Table';
import AvailabilityRowMobile from "./AvailabilityRowMobile";
import {TableHeaderColumn} from "material-ui";
import AvailabilityHeadingMobile from "./AvailabilityHeadingMobile";
import {getRateCurrency, propertyHasRates} from "../../utils/Util";

const AvailabilityTableMobile = ({property, criteria, showRate, customer, displayNoOfNights}) => {
  const rows = [];
  for (let i = 0; i < property.inventory.length; i++) {
    if (property.inventory[i].rateByDay
        && property.inventory[i].rateByDay.length > 0) {
      rows.push(<AvailabilityRowMobile key={i} property={property}
                                       inventoryType={property.inventory[i]}
                                       showRate={showRate} customer={customer}
                                       displayNoOfNights={displayNoOfNights}/>)
    }
  }

  let heading = displayNoOfNights === 1 ? (
      <TableRow style={{height: 1}}>
        <TableHeaderColumn style={{height: 1}}>
        </TableHeaderColumn>
      </TableRow>
  ) : (property ? <AvailabilityHeadingMobile criteria={criteria}
                                             showRate={showRate
                                             && propertyHasRates(property)}
                                             displayNoOfNights={displayNoOfNights}
                                             currency={getRateCurrency(
                                                 property)}
      />
      : <TableRow/>);

  return (
      <div className="availabilityGrid">
        <Table>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            {heading}
          </TableHeader>
          <TableBody>
            {rows}
          </TableBody>
        </Table>
      </div>
  );
};

export default AvailabilityTableMobile;


// WEBPACK FOOTER //
// ./src/components/mobile/AvailabilityTableMobileComponent.js